import React from 'react';
import {
  Container,
  LinearProgress,
  Typography,
  Box,
} from '@material-ui/core';

function Loader({text = "Loading"}) {
  return (
    <Container>
      <Typography variant="h6">{text}</Typography>
      <Box mt={1}>
        <LinearProgress />
      </Box>
    </Container>
  );
}

export default Loader